import * as React from "react";
import * as SRD from "@projectstorm/react-diagrams";
import { Container, Content } from "./Styled";
import Header from "./Header/Header";
import BasePort from "../../port/basePort/BasePort";
import { DefaultNodeModel } from "../../../../model/workflowEditor";
import BuilderContext from "../../../context/BuilderContext";

type BaseWidgetProps = {
  engine: SRD.DiagramEngine;
  node: DefaultNodeModel;
  backgroundColor: string;
};

export const BaseWidget: React.FunctionComponent<BaseWidgetProps> = ({
  engine,
  node,
  backgroundColor,
  children
}) => {
  const { builder } = React.useContext(BuilderContext)

  const renderInPort = (port?: SRD.PortModel | null) => {
    return port ? (
      <BasePort
        style={{
          position: "absolute",
          bottom: "-8px",
          left: "0",
          right: "0",
          marginLeft: "auto",
          marginRight: "auto"
        }}
        engine={engine}
        port={port!}
      />
    ) : null;
  };

  const renderOutPort = (port?: SRD.PortModel | null) => {
    return port ? (
      <BasePort
        style={{
          position: "absolute",
          top: "-10px",
          left: "0",
          right: "0",
          marginLeft: "auto",
          marginRight: "auto"
        }}
        engine={engine}
        port={port!}
      />
    ) : null;
  };

  const removeNode = () => {
    node.remove();
    builder?.repaint();
  }

  return (
    <>
      {renderOutPort(node.getPort("out"))}
      <Container isSelected={node.isSelected()} backgroundColor={backgroundColor}>
        <Header onDelete={removeNode} title={node.title} />
        <Content>
          {children}
        </Content>
      </Container>
      {renderInPort(node.getPort("in"))}
    </>
  );
};

